<template>
  <div>
    <v-dialog v-model="dialog" max-width="1200px" persistent scrollable>
      <v-card>
        <v-card-title class="primary white--text text-uppercase dialog-title">
          Xác nhận xếp phòng kiểm tra
          <v-spacer></v-spacer>
          <v-btn dark icon>
            <v-icon @click="cancel" class="mr-n1" :disabled="loading">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="py-0">
          <ConfirmRoomsTable :documents="importedDocuments" :isImportPreview="true" />
        </v-card-text>
        <v-card-actions class="pa-6">
          <v-btn color="primary" @click="cancel" width="118" :loading="loading" large outlined>Hủy</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="confirm" :loading="loading" width="118" class="white--text elevation-0" large
            >Xác nhận</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ConfirmRoomsTable from './ConfirmRoomsTable.vue'
export default {
  props: {
    importedDocuments: Array,
    state: Boolean
  },
  components: {
    ConfirmRoomsTable
  },

  watch: {
    state(state) {
      this.dialog = state
      if (!state) {
        this.loading = false
      }
    }
  },
  data() {
    return {
      dialog: false,
      loading: false
    }
  },
  methods: {
    cancel() {
      this.$emit('closeDialog')
    },
    stopLoading() {
      this.loading = false
    },
    async confirm() {
      this.loading = true
      this.progressDialog = true
      this.confirmDialog = false
      this.$emit('updateResult', this.importedDocuments)
    }
  }
}
</script>
